import { Component } from '@angular/core';
import { CommonModule } from '@angular/common';
import { OrdersModel } from '../../components/orders/orders-model';
import { BackendService } from '../../services/backend.service';
import { SessionService } from '../../services/session.service';
import { AuthenticationStatus } from '../../util/util';
import { TranslateModule } from '@ngx-translate/core';
import { TitleComponent } from 'src/app/general/components/title/title.component';
import { OrdersComponent } from '../../components/orders/orders.component';
import { PageComponent } from '../../components/page/page.component';
import { OrdersForLaterModel } from '../../components/orders/orders-for-later-model';

@Component({
  selector: 'app-orders-for-later-page',
  standalone: true,
  imports: [
    CommonModule,
    PageComponent,
    TranslateModule,
    OrdersComponent,
    TitleComponent
  ],
  templateUrl: './orders-for-later-page.component.html',
  styleUrls: ['./orders-for-later-page.component.css']
})
export class OrdersForLaterPageComponent {
  ordersForLaterModel: OrdersModel;

  constructor(
      private sessionService: SessionService,
      private backendService: BackendService) {
    this.ordersForLaterModel = new OrdersForLaterModel(this.backendService);
  }

  ngOnInit(): void {
    if (this.sessionService.enforceAuthentication()
        == AuthenticationStatus.USER_NOT_AUTHENTICATED_AND_REDIRECTED_TO_SIGNIN_PAGE) {
      return;
    }
  }
}
